import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { CKEditorUploadAdapter } from 'src/app/_helpers/ckeditor-upload-adapter';
import { InstructorViewModel, PaperSubmissionViewModel, UserSearchParameters, ComposeEmailViewModel, PaperEmailViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AdminCallForPapersService } from 'src/app/_services/generatedServices';
import * as customBuild from 'src/ckCustomBuild/ckeditor';
import { SettingsProvider } from "../../../../../../_services/settingsProvider.service";

@Component({
  selector: 'bxl-add-email-modal',
  templateUrl: 'add-email-modal.component.html',
})
export class AddEmailModalComponent implements OnInit {
  initialized = false;
  public Editor:any = customBuild;
  cc: boolean;
  @ViewChild('myForm') myForm: FormGroupDirective;
  bcc: boolean;
  public userData: Observable<any>;
  @Input()
  organizationId: string;

  @Input()
  conferenceId: number;

  @Input()
  paperSubmission: PaperSubmissionViewModel;

  @Input()
  replyEmail: PaperEmailViewModel;

  @Input()
  forwardEmail: PaperEmailViewModel;

  toolbar: any[];

  model: ComposeEmailViewModel;

  htmlEditorConfig = {
    toolbar: {
      items: ['bold', 'italic', 'underline', 'link', 'alignment', 'bulletedList', 'numberedList', '|', 'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor'],
      shouldNotGroupWhenFull: false,
    },
    fontSize: {
      options: [9, 11, 13, 'default', 17, 19, 21],
    },
    mediaEmbed: {
      previewsInData: true,
    },
  };
  userLoading: boolean;

  constructor(private auth: AuthenticationService, public settings:SettingsProvider, private cfpService: AdminCallForPapersService, private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.model = new ComposeEmailViewModel();
    this.model.to = [this.paperSubmission.submittingUser];
    this.model.cc = [];
    this.model.bcc = [];
    this.model.body = '';
    this.model.subject = '';


    if (this.replyEmail) {
      this.model.to = [this.replyEmail.from];
      this.model.subject = 'Re: ' + this.replyEmail.subject;
      this.model.body = '<br><br><hr>'
      +'<strong>From: </strong> '+ this.replyEmail.from.fullName +' &lt;' + this.replyEmail.from.email + '&gt;<br>'
      +'<strong>Date: </strong> '+ this.replyEmail.createdDate+ '<br>';

      console.log(this.replyEmail);

      if (this.replyEmail.recipients && this.replyEmail.recipients.length > 1){
      this.model.body = this.model.body+'<strong>To: </strong> '+ this.replyEmail.recipients[0].name +' &lt;' + this.replyEmail.recipients[0].emailAddress + '&gt;<br>';
      }else{
        this.model.body = this.model.body+'<strong>To: </strong> Paper Review Team &lt;paper'+ this.paperSubmission.id +'@paper-mail.behaviorlive.com&gt;<br>';
      }

      this.model.body = this.model.body+'<strong>Subject: </strong> '+ this.replyEmail.subject+ '<br>'
      + this.replyEmail.body;
    }

    if (this.forwardEmail) {
      this.model.to = [];
      this.model.subject = 'FW: ' + this.forwardEmail.subject;
      this.model.body = '<br><br><hr>'
      +'<strong>From: </strong> '+ this.forwardEmail.from.fullName +' &lt;' + this.forwardEmail.from.email + '&gt;<br>'
      +'<strong>Date: </strong> '+ this.forwardEmail.createdDate+ '<br>'
      +'<strong>To: </strong> '+ this.forwardEmail.recipients[0].name +' &lt;' + this.forwardEmail.recipients[0].emailAddress+ '&gt;<br>'
      +'<strong>Subject: </strong> '+ this.forwardEmail.subject+ '<br>'
      + this.forwardEmail.body;
    }
    this.handleFilter('');

    this.initialized = true;

    console.log(this.paperSubmission.id);
  }

  public handleFilter(value) {

    this.userLoading = true;
    this.userData = this.cfpService.searchPaperPeople(this.organizationId, this.conferenceId, this.paperSubmission.id, value).pipe(
      debounceTime(500),
      distinctUntilChanged(),
      map((x) => {
        console.log('map');
        return x;
      }),
      tap(() => {
        console.log('tap');
        this.userLoading = false;
      })
    );
  }

  onSave() {
    if (!this.myForm.valid) {
      this.myForm.form.markAllControlsDirty();
      return;
    }

    console.log(this.paperSubmission.id);
    this.cfpService.sendEmail(this.organizationId, this.conferenceId, this.paperSubmission.id, this.model).subscribe((result) => {
      this.activeModal.close(result);
    });
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  public valueNormalizer = (text: Observable<string>) =>
    text.pipe(
      map((content: string) => {
        var model = new InstructorViewModel();
        model.email = content;
        model.fullName = content;
        return <any>model;
      })
    );

  onReady(editor): void {
    // editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    //   return new CKEditorUploadAdapter(loader, this.auth.getToken());
    // };
  }
}
